import DropdownTemplateView from "../../DropdownTemplateView"

export default class AddNewMenu extends DropdownTemplateView {
    constructor({
        importTasksCb = () => {},
        createNewTasksCb = () => {},
        createNewProjectCb = () => {},
        createNewCustomerCb = () => {},
    } = {}) {
        super(null)

        this.callbacks = {
            importTasksCb,
            createNewTasksCb,
            createNewProjectCb,
            createNewCustomerCb,
        }

        this.state = {
            isPossibleToAddCustomers: false,
            isPossibleToAddProjects: false,
        }

        this.onStatePropertyChanged('isPossibleToAddCustomers', show => this.find('.createNewCustomer').toggle(show))
        this.onStatePropertyChanged('isPossibleToAddProjects', show => this.find('.createNewProject').toggle(show))
    }

    templateHtml() {
        return "<div class='dropdownContainer addNewMenu'>" +
               "  <div class='item createNewCustomer'><%-newCustomer%></div>" +
               "  <div class='item createNewProject'><%-newProject%></div>" +
               "  <div class='item createNewTasks'><%-createTasks%></div>" +
               "  <div class='item importTasks'><%-importTasks%></div>" +
               "</div>"
    }

    afterRender() {
        this.findAndBindClick(".createNewCustomer", () => this._handleClick(this.callbacks.createNewCustomerCb))
        this.findAndBindClick(".createNewProject", () => this._handleClick(this.callbacks.createNewProjectCb))
        this.findAndBindClick(".importTasks", () => this._handleClick(this.callbacks.importTasksCb))
        this.findAndBindClick(".createNewTasks", () => this._handleClick(this.callbacks.createNewTasksCb))
        this.renderInitialState()
    }

    messageKeys() {
        return {
            "newCustomer": "task.list.add_new.customer",
            "newProject": "task.list.add_new.project",
            "importTasks": "task.list.add_new.import_tasks",
            "createTasks": "task.list.add_new_tasks",
        }
    }

    _handleClick(callback) {
        this.hide()
        callback()
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/AddNewMenu.js